(function initGravelTop() {
  "use strict";

  const hero = document.querySelector("[data-hero]");
  if (!hero) return;

  const slides = [...hero.querySelectorAll("[data-slide]")];
  const buttons = [...hero.querySelectorAll("[data-slide-button]")];
  const current = hero.querySelector("[data-slide-current]");
  const progress = hero.querySelector("[data-slide-progress]");
  const caption = hero.querySelector("[data-slide-caption]");
  const captionRole = hero.querySelector("[data-slide-caption-role]");
  const link = hero.querySelector("[data-slide-link]");
  const toggle = hero.querySelector("[data-slide-toggle]");
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const content = [
    { caption: "INNER MIND — TOKYO", label: "READ STORY 01", href: "/pages/gravel-running-collection-stories-01" },
    { caption: "OUTER WORLD — KENYA", label: "READ STORY 02", href: "./stories-02/" },
    { caption: "GRAVEL RUNNING COLLECTION", label: "VIEW COLLECTION", href: "/pages/gravel-running-collection-product" },
    { caption: "EVENT LOCATIONS", label: "VIEW EVENT", href: "#tour" }
  ];
  let active = 0;
  let paused = reduceMotion.matches;

  function syncPlaybackState() {
    hero.classList.toggle("is-progress-paused", paused || reduceMotion.matches || document.hidden);
  }

  function restartProgress() {
    progress.classList.remove("is-running");
    void progress.offsetWidth;
    if (!reduceMotion.matches) progress.classList.add("is-running");
    syncPlaybackState();
  }

  function show(index, fromUser) {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const selected = slideIndex === active;
      slide.classList.toggle("is-active", selected);
      slide.setAttribute("aria-hidden", String(!selected));
    });
    buttons.forEach((button, buttonIndex) => button.setAttribute("aria-selected", String(buttonIndex === active)));
    current.textContent = String(active + 1).padStart(2, "0");
    captionRole.textContent = content[active].role || "";
    captionRole.hidden = !content[active].role;
    caption.textContent = content[active].caption;
    link.firstChild.textContent = `${content[active].label} `;
    link.href = content[active].href;
    if (fromUser) restartProgress();
  }

  buttons.forEach((button, index) => button.addEventListener("click", () => show(index, true)));
  toggle.addEventListener("click", () => {
    paused = !paused;
    toggle.setAttribute("aria-pressed", String(paused));
    toggle.setAttribute("aria-label", paused ? "スライドショーを再生" : "スライドショーを一時停止");
    toggle.textContent = paused ? "▶" : "Ⅱ";
    syncPlaybackState();
  });
  progress.addEventListener("animationend", () => {
    if (!paused && !reduceMotion.matches && !document.hidden) show(active + 1, true);
  });
  document.addEventListener("visibilitychange", syncPlaybackState);
  reduceMotion.addEventListener?.("change", restartProgress);
  show(0, false);
  restartProgress();

  const terrains = [
    ["SURFACE 01 / 03", "CITY", "ASPHALT / TOKYO"],
    ["SURFACE 02 / 03", "GRAVEL", "LOOSE STONE / BETWEEN"],
    ["SURFACE 03 / 03", "WILD", "EARTH / KENYA"]
  ];
  document.querySelector("[data-stage]")?.addEventListener("gravel:phase", ({ detail }) => {
    const [number, name, note] = terrains[detail.phase];
    const terrainName = document.querySelector(".terrain-name");
    if (terrainName) {
      terrainName.querySelector("small").textContent = number;
      terrainName.querySelector(".terrain-name__title").textContent = name;
      terrainName.querySelector(".terrain-name__title + p").textContent = note;
    }
    document.querySelectorAll("[data-surface]").forEach((item, index) => item.classList.toggle("is-active", index === detail.phase));
  });
})();
